<template>
    <div class="userinfo clearfix">
        <div class="current">
            <p>当前位置：首页>我的再认证</p>
        </div>
        <div class="menu clearfix">
            <center-menu active="5" />
        </div>
        <div class="content clearfix">
            <div class="title">
                <h1>我的再认证  <span> / My re-certification</span></h1>
            </div>
            <ul>
                <li v-for="val in datalist">
                    <h1>{{val.examType | testfilters}}再认证</h1>
                    <p>姓名：{{val.userName}}</p>
                    <p>再认证等级：{{val.examType | testfilters}}</p>
                    <p>{{val.examType | testfilters}}认证时间：{{val.firstCertDate | dateTime('yyyy年MM月dd日')}}</p>
					<p v-if="val.certStartDate">您本次再认证周期：    {{val.certStartDate | dateTime('yyyy年MM月dd日')}}    至    {{val.certEndDate | dateTime('yyyy年MM月dd日')}}</p>
                    <p>您本次再认证状态：{{renzhenglis[val.recertStatus-1]}}</p>
					<p v-if="!val.certStartDate">&nbsp;</p>
                    <div class="buttons">
                        <el-button v-if="val.id" @click="see(val.id,val.enrollId)">查看详情</el-button>
                        <el-button v-if="val.recertStatus!=3&&val.recertStatus!=4" @click="goAttestation(val.id,val.enrollId)">去认证</el-button>
                    </div>
                </li>
            </ul>
        </div>
		<p style="text-align: center;" v-if="!total">暂无数据</p>
		<div class="lookfor">
			<pagination class="loooo" v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />
		</div>
    </div>
</template>

<script>
import { EnrollInfoListRecertPage,enrollInfoRecertEnroll } from '@/api/center'
import pagination from '@/components/pagination'	
export default {
    name: 'myCertification',
    data(){
        return {
			renzhenglis:['未达标','达标未申请','待发证','已发证'],
			total:0,
			listQuery: {
				pageNum: 1,
				pageSize: 4,
				type: 3,
				userId: this.$store.getters.userInfo.id
			},
			datalist:[]
        }
    },
	components: {
		pagination
	},
    mounted(){
		this.getList()
    },
    methods:{
        see(id,ids){
            // this.$route.query.id
            this.$router.push({
                path: '/center/reCertification',
                // name: 'mallList',
                query: {
					id,
                    ids,
					see:1
                }
            })
        },
		goAttestation(id,ids){
			this.$router.push({
				path: '/center/InformationValidation',
				query: {
					id,
					ids
				}
			})
		},
		getList(){
			EnrollInfoListRecertPage(this.listQuery).then(res => {
				console.log(res)
				this.total=res.total
				this.datalist=res.list
			})
		}
    }
}
</script>

<style scoped>
    .menu{float: left;width: 170px;}
    .content{float: right;width: 1028px;}
	.content  .buttons{margin-left: 25px;margin-top: 43px;}
	.userinfo .content  .getcode >>> button {margin-left: 20px;}
    .center .main a+a {
        margin-left: 40px;
    }
    .buttons{
        text-align: center;
    }
    ul li{
        float: left;
        width: 500px;
        border: 1px solid #ccc;
        margin-top: 20px;
        padding: 0 20px 20px;
        box-sizing: border-box;
		height: 300px;
    }
    ul li h1{
        line-height: 40px;
        border-bottom: 1px solid #e6e6e6;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    ul li p{
        line-height: 30px;
    }
    ul li:nth-of-type(2n){
        margin-left: 25px;
    }
	.userinfo .content .lookfor >>>.el-input {width: 55px;}
	.lookfor-detail {display: inline-block;cursor: pointer;width: 80px;text-align: center;}
	.lookfor {float: left;width: 85%;margin-left: 15%;}
	.loooo{text-align: center;margin: 0 auto;}
</style>
